<!-- WLAN Status eines Devices anzeigen -->
<template>

    <span v-if="value">

      <span v-if="hasBadWifi === false"
            v-b-tooltip.hover
            :title="$t('message.traplinkedStatus_unstableWifi_b')">
        <b-icon icon="wifi" style="color: #73b025"></b-icon>
      </span>
      <span v-else-if="hasBadWifi"
            v-b-tooltip.hover
            :title="$t('message.traplinkedStatus_unstableWifi_a')">
        <b-icon icon="wifi-off" style="color: #e3150f"></b-icon>
      </span>

    </span>

</template>
<script>

  import axios from "axios";

  export default {

    name: 'DeviceWifi',
    props: [
        'value', // Traplinked Device
    ],
    data () {
      return {
        hasBadWifi: null,
      }
    },
    watch: {
      value: function () {
        this.init()
      }
    },
    methods: {

      init: function () {

        const url    = process.env.VUE_APP_SERVER_URL + '/datenbroker/hasUnstableWifi'
        const params = {
          device_id: this.value.id,
        }
        axios({
          method: 'GET',
          params: params,
          url: url
        }).then(response => {

          this.hasBadWifi = response.data.unstable_wifi

        }).catch(error => {
          console.log(error)
        })

      }

    },
    mounted: function () {
      this.init()
    }

  }

</script>